import { FC, memo, useEffect, useState } from 'react'
import { AppBar, Container, Link, Toolbar } from '@mui/material'
import Cookies from 'universal-cookie'
import { LoggedInSection } from './LoggedInSection'
import { LoggedOutSection } from './LoggedOutSection'
import HeaderSearchInput from '@components/Header/HeaderSearchInput/HeaderSearchInput'
import { useAuth } from 'layouts/AuthContext'
import { ProfileInterface } from '@state/profile/profileStateSlice'
import keycloak from '../../keycloak'

const Header: FC = () => {
  const { getMemberProfile, isAuthenticated } = useAuth()
  const cookie = new Cookies()
  const [profile, setProfile] = useState<ProfileInterface | null>(() => null)

  useEffect(() => {
    setProfile(getMemberProfile())
  })

  useEffect(() => {
    if (!keycloak.authenticated) return

    const refreshToken = () => {
      keycloak
        .updateToken(60)
        .then((refreshed: boolean) => {
          if (refreshed) {
            cookie.set('access-token', keycloak.token, { path: '/' })
          }
        })
        .catch(() => {
          cookie.remove('access-token')
          window.sessionStorage.removeItem('logged')
        })
    }

    const interval = setInterval(refreshToken, 60000)
    return () => clearInterval(interval)
  }, [keycloak.authenticated])

  return (
    <AppBar
      position='relative'
      sx={{
        background: 'rgba(0,0,0,0)',
        borderBottom: 'solid 1px rgba(255,255,255,.1)',
      }}
    >
      <Container disableGutters={true}>
        <Toolbar disableGutters={true} sx={{ padding: '0 20px', justifyContent: 'space-between' }}>
          <Link href='/' sx={{ minHeight: '106px', display: 'flex', alignItems: 'center', mr: '40px' }}>
            <img src={'../images/logo.png'} alt='' />
          </Link>
          <HeaderSearchInput />
          {isAuthenticated ? <LoggedInSection memberProfile={profile} /> : <LoggedOutSection />}
        </Toolbar>
      </Container>
    </AppBar>
  )
}
export default memo(Header)
